<template>
  <div class="home">
    <v-carousel
      hide-delimiters
      hide-arrows
      :left-control-icon="false"
      :right-control-icon="false"
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        reverse-transition="fade-transition"
        transition="fade-transition"
      ></v-carousel-item>
    </v-carousel>
    <v-card>
      <v-card-title class="display-3">
        Mittagsmenü
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :items-per-page="-1"
        ><template v-slot:item.speise="{ item }">
          <b>{{ item.speise }}</b>
        </template>
        <template v-slot:item.preis="{ item }">
          <b>{{ item.preis }}</b>
        </template></v-data-table
      >
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Mittagsmenuekarte',
  data() {
    return {
      items: [
        {
          src: require('../assets/images/mittagsmenueteller.jpg'),
        },
      ],
      search: '',
      headers: [
        {
          text: 'Nummer',
          align: 'start',
          sortable: false,
          value: 'nummer',
        },
        { text: 'Speise', value: 'speise' },
        { text: 'Allergene', value: 'allergene' },
        { text: 'Preis', value: 'preis' },
      ],
      desserts: [
        {
          nummer: 'M1',
          speise: 'gebackene Garnelen',
          allergene: '(A, B, F, R)',
          preis: '12,20 €',
        },
        {
          nummer: 'M2',
          speise: 'Gebratener Tofu mit Gemüse',
          allergene: '(A, F)',
          preis: '9,70 €',
        },
        {
          nummer: 'M3',
          speise: 'Gebratenes Rindfleisch mit Zwiebeln',
          allergene: '(F)',
          preis: '10,00 €',
        },
        {
          nummer: 'M4',
          speise: 'Gemischter gebratener Fischteller mit Gemüse',
          allergene: '(D)',
          preis: '10,00 €',
        },
        {
          nummer: 'M5',
          speise: 'Nudeln mit Rindfleisch oder Hühnerfleisch oder Garnelen',
          allergene: '(A, B, F)',
          preis: '9,00 €',
        },
        {
          nummer: 'M6',
          speise:
            'Gebratener Reis mit Rindfleisch oder Hühnerfleisch oder Garnelen',
          allergene: '(A, B, C, F)',
          preis: '9,00 €',
        },
        {
          nummer: 'M7',
          speise: 'Sushi Set klein (7 Sushi und 3 Maki)',
          allergene: '(C, D)',
          preis: '10,20 €',
        },
        {
          nummer: 'M8',
          speise: 'Maki im Set (15 Stk.)',
          allergene: '(C, D, N)',
          preis: '10,20 €',
        },
        {
          nummer: 'M9',
          speise: 'Knusprige Ente',
          allergene: '(A, F)',
          preis: '10,40 €',
        },
        {
          nummer: 'M10',
          speise: 'Hühnerfleisch mit Sesam, paniert',
          allergene: '(C, F, N)',
          preis: '9,90 €',
        },
        {
          nummer: 'M11',
          speise: 'Gebratenes Hühnerfleisch mit Gemüse',
          allergene: '(F)',
          preis: '9,90 €',
        },
        {
          nummer: 'M12',
          speise: 'Ente mit gegrillten Fleischtaschen',
          allergene: '(A, F)',
          preis: '10,50 €',
        },
        {
          nummer: 'M13',
          speise: 'Knuspriges Huhn',
          allergene: '(A, F)',
          preis: '10,00 €',
        },
        {
          nummer: 'M14',
          speise: 'gemischte knusprige Teigtaschen (12 Stk.)',
          allergene: '(A, E, F, N)',
          preis: '12,20 €',
        },
        {
          nummer: 'M15',
          speise: 'Gegerilltes Lachssteak mit Gemüse',
          allergene: '(A, D)',
          preis: '11,80 €',
        },
        {
          nummer: 'M16',
          speise: 'Gebratene Udonnudel mit Hühnerfleisch oder Rindfleisch oder Garnelen',
          allergene: '(A, C, E, F, H)',
          preis: '9,80 €',
        },
        {
          nummer: 'M17',
          speise: 'Hühnerfleisch mit Gemüse und Erdnüsse',
          allergene: '(E, F)',
          preis: '9,80 €',
        },
        {
          nummer: 'M18',
          speise: 'Gebratener Lachs mit Gemüse und Teriyaki Sauce',
          allergene: '(A, D)',
          preis: '10,50 €',
        },
        {
          nummer: 'M19',
          speise: 'Acht Schätze (scharf)',
          allergene: '(A, F)',
          preis: '10,80 €',
        },
        {
          nummer: 'M20',
          speise: 'Hühnerfleisch mit Bambus und Pilzen',
          allergene: '(F)',
          preis: '10,20 €',
        },
        {
          nummer: 'M21',
          speise: 'Nudeln mit knuspriger Ente oder knusprigem Huhn',
          allergene: '(A, F)',
          preis: '10,80 €',
        },
        {
          nummer: 'M22',
          speise: 'Rindfleisch mit Bambus und Pilzen',
          allergene: '(A, F)',
          preis: '10,40 €',
        },
        {
          nummer: 'M23',
          speise: 'Rindfleisch nach Sichuan Art (scharf)',
          allergene: '(A, F)',
          preis: '10,40 €',
        },
        {
          nummer: 'M24',
          speise: 'Rindfleisch nach Chop Suey',
          allergene: '(A, F)',
          preis: '10,40 €',
        },
        {
          nummer: 'M25',
          speise: 'Rindfleisch mit Thai Sauce',
          allergene: '(A, F)',
          preis: '10,70 €',
        },
        {
          nummer: 'M26',
          speise: 'Hühnerfleisch Chop Suey',
          allergene: '(A, F)',
          preis: '10,00 €',
        },
        {
          nummer: 'M27',
          speise: 'Hühnerfleisch nach Sichuan Art (scharf)',
          allergene: '(A, F)',
          preis: '10,00 €',
        },
        {
          nummer: 'M28',
          speise: 'Hühnerfleisch mit Thai Sauce',
          allergene: '(A, F)',
          preis: '10,00 €',
        },
        {
          nummer: 'M29',
          speise:
            'Gebratener Eierreis mit knuspriger Ente oder knusprigem Huhn',
          allergene: '(A, C, F)',
          preis: '10,90 €',
        },
        {
          nummer: 'M30',
          speise: 'Gebratenes Hühnerfleisch mit Teriyaki Sauce',
          allergene: '(A, F)',
          preis: '10,20 €',
        },
        // {
        //   nummer: 'M31',
        //   speise: 'Gegrillte Fleischtaschen mit Teriyaki Sauce (10 Stk.)',
        //   allergene: '(A, F, N)',
        //   preis: '9,50 €',
        // },
      ],
    };
  },
  methods: {
    top() {
      window.scrollTo(0, 0);
    },
  },
  created() {
    this.top();
  },
};
</script>

<style lang="scss" scoped></style>
